import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const searchQuery = async (params) => {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ""))
  ).toString();
  const response = await axios.get(`${apiRoutes.SEARCH}?${qs}`);
  return response.data;
};
